export default "Bonification CEE pour PAC, CTA double flux et raccordement réseau de chaleur sur bâtiments tertiaires. Cumulable avec la prime CEE BAT-TH de base.";
